module.exports = "/img/mercedes.f905ca7c.png";